import React from 'react';
import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';
import './index.css';

export const createRoot = ViteReactSSG(
  { routes },
  (ctx) => {
    // Custom setup if needed
  }
);
